import { getClipPresenterDrivers } from '@/services/api';
import { Presenter } from '@d-id/types';
import { useQuery } from 'react-query';

export const GET_CLIP_PRESENTER_DRIVERS_KEY = 'GET_CLIP_PRESENTER_DRIVERS_KEY';

export const useClipPresenterDrivers = (avatar: Presenter | undefined) => {
    return useQuery([GET_CLIP_PRESENTER_DRIVERS_KEY, avatar?.id], getClipPresenterDrivers(avatar?.id || ''), {
        placeholderData: [],
        enabled: !!avatar,
    });
};
